<template>
  <div class="page">
    <my-menu />
    <router-view></router-view>
    <my-bottom />
  </div>
</template>

<script>
import MyMenu from "@/components/MyMenu";
import MyBottom from "@/components/MyBottom";
export default {
  name: "app",
  components: { MyMenu, MyBottom },
  data() {
    return {
      abc: "1"
    };
  }
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
}
.page {
  width: 100%;
}
</style>
